/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { ValidateCalculateCaseResponseJson } from './validate-calculate-case-response-json';
import { GenericClearanceCaseResult } from '../results/generic-clearance-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CustomsValidatorResult } from './customs-validator-result';
import { SchemaValidationResult } from '../models/schema-validation-result';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class ValidateCalculateCaseResponse extends ResponseWithErrorGeneric<ValidateCalculateCaseResponseJson, GenericClearanceCaseResult> implements IResponseWithErrorGeneric<GenericClearanceCaseResult> {
  public calculationResults: CustomsValidatorResult[];
  public validationResults: SchemaValidationResult[];

  //<custom-body>
  constructor(response: HttpResponse<ValidateCalculateCaseResponse>) {
    super(response, GenericClearanceCaseResult.Error);
    if (!response.body || response.body.result === GenericClearanceCaseResult.Error) return;
    this.calculationResults = response.body.calculationResults;
    this.validationResults = response.body.validationResults;
  }
  //</custom-body>
}
